export const micRecording = {
  title: {
    "en": "Recording in-progress",
    "hi": "रिकॉर्डिंग जारी है",
    "or": "ରେକର୍ଡିଂ ଚାଲିଛି",
  },
  subtitle: {
    "en": "Click stop when done",
    "hi": "रिकॉर्डिंग बंद करने के लिए “बंद करें” दबाएँ।",
    "or": "ରେକର୍ଡିଂ ହୋଇଗଲେ 'ବନ୍ଦ କରନ୍ତୁ' କ୍ଲିକ୍ କରନ୍ତୁ"
  },
  stop: {
    "en": "Stop",
    "hi": "बंद करें",
    "or": "ବନ୍ଦ କରନ୍ତୁ",
  }
};

export const recordedAudio = {
  title: {
    "en": "Verify your question below",
    "hi": "अपना सवाल जांच लें।",
    "or": "ତଳେ ଦିଆଯାଇଥିବା ଆପଣଙ୍କ ପ୍ରଶ୍ନ ଯାଞ୍ଚ କରନ୍ତୁ:",
  },
  recordAgain: {
    "en": "Delete",
    "hi": "डिलीट",
    "or": "ଡିଲିଟ୍ କରନ୍ତୁ",
  },
  send: {
    "en": "Send",
    "hi": "भेजें",
    "or": "ପଠାନ୍ତୁ"
  }
};

export const deleteAudio = {
  title: {
    "en": "Delete this recording?",
    "hi": "रिकॉर्डिंग डिलीट करें?",
    "or": "ଏହି ରେକର୍ଡିଂ ଡିଲିଟ୍ କରିବେ କି?",
  },
  yes: {
    "en": "Delete and go to chat",
    "hi": "डिलीट करें और चैट पर वापस जाएं",
    "or": "ଡିଲିଟ୍ /ବିଲୋପ କରନ୍ତୁ ଏବଂ ଚାଟ୍‌କୁ ଯାଆନ୍ତୁ",
  },
  no: {
    "en": "No, go back to editing",
    "hi": "नहीं, एडिट पर लौटें",
    "or": "ନା, ଏଡିଟିଂକୁ ଫେରି ଯାଆନ୍ତୁ",
  }
};
